// import React, { useState, useEffect } from "react";
// import { CircularProgress, TextField, Button } from "@mui/material";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import config from "../../config";

// const baseUrl = config.baseURL;

// const PaymentPage = () => {
//   const [cardDetails, setCardDetails] = useState({
//     cardNumber: "",
//     expiryDate: "",
//     cardHolderName: "",
//     cvc: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(""); // Error state for handling errors
//   const [planId, setPlanId] = useState(null);
//   const [companyId, setCompanyId] = useState(null);

//   // Retrieve planId from URL query parameters using useLocation
//   const location = useLocation();

//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const planId = queryParams.get("planId");
//     setPlanId(planId);

//     // Handle if planId is not found in the URL
//     if (!planId) {
//       setError("No pricing plan selected. Please go back and choose a plan.");
//     }

//     // Get the token from local storage
//     const token = localStorage.getItem("token");

//     if (token) {
//       const decodedToken = JSON.parse(atob(token.split(".")[1])); // Decode the JWT token
//       setCompanyId(decodedToken.companyId); // Retrieve companyId from the token
//     }
//   }, [location]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCardDetails((prevDetails) => ({
//       ...prevDetails,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     setError(""); // Reset error message

//     if (!companyId) {
//       alert("You need to register and provide your company ID first!");
//       window.location.replace("/Register"); // Redirect to registration page if no companyId is found
//       return;
//     }

//     try {
//       // Send payment details along with the plan ID and companyId to the backend server
//       const token = localStorage.getItem("token");

//       const response = await axios.post(
//         `${baseUrl}/api/payment`, // API endpoint
//         {
//           ...cardDetails,
//           planId, // Include the plan ID in the request body
//           companyId, // Include companyId in the request body
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`, // Send the token as Authorization header
//           },
//         }
//       );

//       // If payment is successful
//       if (response.data.success) {
//         alert("Payment submitted successfully!");
//         // Redirect or handle after successful payment (e.g., navigate to dashboard)
//         window.location.replace("/dashboard");
//       } else {
//         setError("Payment failed. Please try again.");
//       }
//     } catch (err) {
//       setError("Error: Unable to contact the server. Please try again.");
//       console.error(err);
//     } finally {
//       setLoading(false); // Stop the loading spinner
//     }
//   };

//   const handleBack = () => {
//     // Logic to go back to the previous step (e.g., to pricing page or registration)
//     window.history.back();
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: "20px",
//         backgroundColor: "#F4F6F9", // Using a soft background color for payment page
//         minHeight: "100vh",
//       }}
//     >
//       <div style={{ width: "100%", maxWidth: "400px", textAlign: "center" }}>
//         <h1 style={{ color: "#2E4053" }}>Payment Details</h1>

//         {/* Payment Form */}
//         <TextField
//           label="Card Number"
//           variant="outlined"
//           name="cardNumber"
//           value={cardDetails.cardNumber}
//           onChange={handleChange}
//           fullWidth
//           required
//           style={{
//             marginBottom: "10px",
//             backgroundColor: "#FFFFFF", // White background for input fields
//           }}
//         />
//         <TextField
//           label="Expiry Date (MM/YY)"
//           variant="outlined"
//           name="expiryDate"
//           value={cardDetails.expiryDate}
//           onChange={handleChange}
//           fullWidth
//           required
//           style={{
//             marginBottom: "10px",
//             backgroundColor: "#FFFFFF", // White background for input fields
//           }}
//         />
//         <TextField
//           label="Cardholder Name"
//           variant="outlined"
//           name="cardHolderName"
//           value={cardDetails.cardHolderName}
//           onChange={handleChange}
//           fullWidth
//           required
//           style={{
//             marginBottom: "10px",
//             backgroundColor: "#FFFFFF", // White background for input fields
//           }}
//         />
//         <TextField
//           label="CVC"
//           variant="outlined"
//           name="cvc"
//           value={cardDetails.cvc}
//           onChange={handleChange}
//           fullWidth
//           required
//           style={{
//             marginBottom: "10px",
//             backgroundColor: "#FFFFFF", // White background for input fields
//           }}
//         />

//         {error && <p style={{ color: "#FF0000" }}>{error}</p>}

//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <Button
//             variant="outlined"
//             style={{
//               backgroundColor: "#A6AAAD", // Muted grayish-blue for back button
//               color: "#2E4053", // Dark blue text
//             }}
//             onClick={handleBack}
//           >
//             Back
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleSubmit}
//             disabled={loading}
//             style={{
//               backgroundColor: "#2E4053", // Dark blue for submit button
//               color: "#FFFFFF", // White text
//             }}
//           >
//             {loading ? (
//               <CircularProgress size={24} style={{ color: "#FFFFFF" }} />
//             ) : (
//               "Submit Payment"
//             )}
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentPage;
// /frontend/pages/payment.js
// /frontend/pages/payment.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import config from "../../config";

const baseUrl = config.baseURL;
console.log("Config:", config);
console.log("Stripe key:", config.STRIPE_PUBLIC_KEY);

// Load your Stripe publishable key here (set in your .env or config)

const stripePromise = config.STRIPE_PUBLIC_KEY
  ? loadStripe(config.STRIPE_PUBLIC_KEY)
  : null;

const CheckoutForm = ({ planId, companyId }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (!stripe || !elements) {
      return;
    }
    setLoading(true);

    try {
      // Create PaymentMethod with card details from Stripe Elements
      const cardElement = elements.getElement(CardElement);
      const { error: paymentMethodError, paymentMethod } =
        await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
        });

      if (paymentMethodError) {
        setError(paymentMethodError.message);
        setLoading(false);
        return;
      }

      // Get auth token
      const token = localStorage.getItem("token");

      // Call your backend to process payment
      const response = await axios.post(
        `${baseUrl}/api/payment`,
        {
          planId,
          companyId,
          paymentMethodId: paymentMethod.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        window.location.href = "/successpage";
      } else {
        window.location.href = "/cancelpage";
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          "Payment processing failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: 400,
        margin: "auto",
        padding: 20,
        backgroundColor: "#F4F6F9",
        borderRadius: 8,
      }}
    >
      <h2 style={{ textAlign: "center", color: "#2E4053" }}>Payment Details</h2>

      <div
        style={{
          padding: "10px 14px",
          border: "1px solid #ccc",
          borderRadius: 4,
          backgroundColor: "#fff",
          marginBottom: 20,
        }}
      >
        <CardElement options={{ hidePostalCode: true }} />
      </div>

      {error && (
        <div
          style={{
            color: "red",
            marginBottom: 20,
            textAlign: "center",
          }}
        >
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={!stripe || loading}
        style={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#2E4053",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: loading ? "default" : "pointer",
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {loading ? "Processing..." : "Pay"}
      </button>
    </form>
  );
};

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [planId, setPlanId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const plan = queryParams.get("planId");

    if (!plan) {
      setError("No pricing plan selected. Please go back and choose a plan.");
      return;
    }
    setPlanId(plan);

    // Get companyId from token
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login first.");
      navigate("/Register");
      return;
    }

    try {
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      if (!decodedToken.companyId) {
        setError("Invalid session: no company ID found.");
        return;
      }
      setCompanyId(decodedToken.companyId);
    } catch {
      setError("Invalid token. Please login again.");
      navigate("/Register");
    }
  }, [location, navigate]);

  if (error) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: 100,
          color: "red",
          maxWidth: 400,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h2>{error}</h2>
      </div>
    );
  }

  if (!planId || !companyId) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <h2>Loading payment page...</h2>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm planId={planId} companyId={companyId} />
    </Elements>
  );
};

export default PaymentPage;
